import { render, staticRenderFns } from "./account_record.vue?vue&type=template&id=66b84fe4&scoped=true"
import script from "./account_record.vue?vue&type=script&lang=js"
export * from "./account_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b84fe4",
  null
  
)

export default component.exports